module.exports = __webpack_public_path__ + "img/8.0569c0cb.png";